import React from 'react'
import T from 'prop-types'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import Notice from 'components/common/Notice/Notice'
import { isIE, URL_ECTO_WATER_FORM, URL_ECTO } from 'constants/index'
import './auth.scss'

function AuthLayout({ children, className }) {
  return (
    <div className="auth-layout">
      <Notice />
      <div className="auth-main">
        <div className="main-header">
          <Link to="/" className="mobile-logo">
            <img src="/assets/images/mobile-ecto-logo.svg" alt="ecto logo" />
          </Link>
        </div>
        <div className={cn('main-body', className, { 'ie-wrap': isIE })}>
          {children}
          <div className="auth-link-box">
            <a
              href={URL_ECTO_WATER_FORM}
              className="auth-login-link desktop"
              target="_blank"
              rel="noopener noreferrer">
              {URL_ECTO}
            </a>
          </div>
        </div>
      </div>
      <div className="auth-inform">
        <div className="logo">
          <img src="/assets/images/ecto-logo.svg" alt="ecto logo" />
        </div>
      </div>
      <div className="auth-login-link-box">
        <a
          href={URL_ECTO_WATER_FORM}
          className="auth-login-link mobile"
          target="_blank"
          rel="noopener noreferrer">
          {URL_ECTO}
        </a>
      </div>
    </div>
  )
}

AuthLayout.propTypes = {
  children: T.node.isRequired,
  className: T.string,
}

AuthLayout.defaultProps = {
  className: '',
}

export default AuthLayout
